import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-status',
  templateUrl: './onlinestatus.component.html',
  styleUrls: ['./onlinestatus.component.css']
})
export class OnlinestatusComponent implements OnInit {
  @Input() onlineStatusMessage: string;
  @Input() onlineStatus: string;
  constructor() { }

  ngOnInit() {
  }
}
